

const tableColumnsBuilder = (
  filterRender,
  impactProperties,
  booleanCell,
  linkCell,
  dateFilterRender,
  dateCell,
  fields,
  selected_columns
) => {
  let columns = [
    {
      header : 'Name',
      accessor : 'name',
      filterRender : filterRender,
      render : linkCell
    },
    {
      header : 'Email',
      accessor : 'email',
      filterRender : filterRender,
    },
    {
      header : 'Street',
      accessor : 'address.street',
      filterRender : filterRender,
    },
    {
      header : 'City',
      accessor : 'address.city',
      filterRender : filterRender,
    },
    {
      header : 'State',
      accessor : 'address.state',
      filterRender : filterRender,
    },
    {
      header : 'Zip',
      accessor : 'address.zip',
      filterRender : filterRender,
    },
    {
      header : 'Last Impact',
      accessor : 'last_impact_report.map_properties.storm_date',
      filterRender : dateFilterRender,
      render : dateCell
    },
    {
      header : 'Last Impact Details',
      accessor : 'last_impact_report.feature_properties',
      filterRender : filterRender,
      render : impactProperties,
      hideFilter : true
    },
    {
      header : 'Geocoded',
      accessor : 'address.geocoded',
      filterRender : filterRender,
      render : booleanCell,
      hideFilter : true
    }
  ];

  fields.forEach(field => {
    if(!columns.find(col => col.accessor == field.name)) {
      const { label, name, type } = field;
      const is_checkbox = type == 'checkbox';
      const field_col = {
        header : label || '',
        accessor : name,
        filterRender : filterRender,
        render : is_checkbox ? booleanCell : null,
        hideFilter : is_checkbox
      }

      columns.push(field_col);
    }
  });

  return columns.filter(col => selected_columns.find(s_col => s_col == col.accessor) != null);
}

export default tableColumnsBuilder;



// WEBPACK FOOTER //
// ./src/browser/components/clients/utils/table-columns-builder.js